export const formatCount = (n) => Number(n || 0).toLocaleString('en-US');

// "1 host", "12 hosts". Pass the plural when it isn't just noun + "s".
export const plural = (n, noun, pluralNoun = `${noun}s`) => `${formatCount(n)} ${n === 1 ? noun : pluralNoun}`;

// ISO timestamps from the API shown as YYYY-MM-DD; null when missing.
export const formatDate = (value) => (value ? String(value).slice(0, 10) : null);

// ISO timestamps as local YYYY-MM-DD HH:mm; null when missing.
export const formatDateTime = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const TEAMS = { dba: 'DBA', devops: 'DevOps', enterprise: 'Enterprise', cve: 'CVE', package: 'Package', 'container-image': 'Container image' };
const ENVIRONMENTS = { bsg: 'BSG', enterprise: 'Enterprise' };

// Display names for the API's team_flow and region values; unknown values pass through, empty gives null.
export const teamLabel = (team) => (team ? TEAMS[String(team).toLowerCase()] || team : null);
export const environmentLabel = (region) => (region ? ENVIRONMENTS[String(region).toLowerCase()] || region : null);
